import React from 'react';
import {
  addPathToList,
  Configure_screen_amount,
  Enable_additional_instructions,
  Enter_amount,
  getSubCategoryId,
  show_Balance,
  Transfer_amount,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import SwitcherPanel from '../components/PanelsComponents/Buttons/SwitcherPanel';
import { arrangeScreenInJson } from '../screens/ScreensOrdering';

//= ========================================================================
const Panel_B08_SendMoneyEnterAmount = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => {
  const editTextList = [
    'how_much_to_transfer',
    'please_enter_valid_amount',
  ];
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const { amount } = globJSON.configurations.services[subCategoryId];
  const onValueChanged = (key, value) => {
    amount[key] = value;
    arrangeScreenInJson(globJSON, onConfigChanged);
  };

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      onGotoEdit={onGotoEdit}
      panelHeadline={Transfer_amount}
      panelSubHeadline={Enter_amount}
      editTextList={addPathToList(editTextList, `configurations/services/${subCategoryId}/amount/`)}
      tooltipsTitles={globJSON.configurations.services[subCategoryId].screens_ordering}
      paragraph={Configure_screen_amount}
      language={language}
    >
      <SwitcherPanel
        text={show_Balance}
        value={amount.show_account_balance}
        onValueChanged={(value) => {
          onValueChanged('show_account_balance', value);
        }}
      />
      <SwitcherPanel
        text={Enable_additional_instructions}
        value={amount.enable_additional_instruction}
        onValueChanged={(value) => {
          onValueChanged('enable_additional_instruction', value);
        }}
        marginTop={13}
        marginBottom={30}
      />
    </FullPagePanel>
  );
};

export default Panel_B08_SendMoneyEnterAmount;
